import styled from 'styled-components';
import { resetBtn } from 'styled-manila';
import { getColor } from 'core/utils/Styles';

export const LikesBtn = styled.button`
	${resetBtn};
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 4px;
	min-height: 42px;

	svg {
		max-width: none;
	}
`;

export const Likes = styled.span`
	font-size: 16px;
	letter-spacing: 0.2px;
	color: ${getColor('dustyGray')};
	margin-left: 8px;
	position: relative;
	overflow: hidden;
	text-overflow: ellipsis;
`;
